document.addEventListener('change', function (event) {
  const input = event.target;

  if (!input.matches('.collection-product-card__swatch input[type="radio"]')) return;

  const card = input.closest('[data-card-product]');
  if (!card) return;

  const mainImage = card.querySelector('[data-card-main-image]');
  if (!mainImage) return;

  const variantId = input.dataset.variantId;
  if (!variantId) return;

  const swatchWrapper = input.closest('.card-product-custom-div');
  if (!swatchWrapper) return;

  const sectionId = (swatchWrapper.dataset.sectionId || '').replace(/-/g, '_');
  const productId = swatchWrapper.dataset.productId;

  if (!sectionId || !productId) return;

  const mapName = `variantDataMap${sectionId}_${String(productId).replace(/-/g, '_')}`;
  const variantMap = window[mapName];

  if (!variantMap || !variantMap[variantId]) return;

  const imageUrl = variantMap[variantId].imageUrl;
  const productUrl = variantMap[variantId].productUrl;

  if (imageUrl) {
    mainImage.src = imageUrl;
    mainImage.srcset = '';
  }

  const productLinks = card.querySelectorAll('a[href*="/products/"]');
  productLinks.forEach((link) => {
    if (productUrl) {
      link.href = productUrl;
    }
  });
});